import React, { useState, useEffect } from "react";
import { Lock, Unlock } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { SalesPanel, computeSalesOpen, modeFromSettings, applyMode } from "./sales/SalesPanel";
import { logger } from "../lib/logger";

export const SalesControl = () => {
  const { isAdmin } = useAuth();
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("always_open");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [loading, setLoading] = useState(false);
  const [isOpenNow, setIsOpenNow] = useState(true);

  const sync = (s) => {
    setMode(modeFromSettings(s));
    setStart(s.sales_start || "");
    setEnd(s.sales_end || "");
    setIsOpenNow(computeSalesOpen(s));
  };

  useEffect(() => {
    if (!isAdmin) return;
    api.get("/settings").then((r) => sync(r.data || {})).catch((e) => logger.error("settings load failed", e));
  }, [isAdmin]);

  if (!isAdmin) return null;

  const save = async () => {
    setLoading(true);
    try {
      const { data: s } = await api.get("/settings");
      const payload = applyMode(s, mode, start, end);
      await api.put("/settings", payload);
      sync(payload);
      toast.success(computeSalesOpen(payload) ? "البيع مفتوح الآن" : "تم إيقاف البيع");
      setOpen(false);
    } catch (e) {
      logger.error("sales save failed", e);
      toast.error("تعذّر الحفظ");
    }
    setLoading(false);
  };

  return (
    <>
      <button
        onClick={() => setOpen(!open)}
        data-testid="admin-sales-fab"
        title="التحكم ببيع العطر"
        className={`fixed bottom-6 start-6 z-[60] w-14 h-14 rounded-full flex items-center justify-center shadow-xl transition-colors ${isOpenNow ? "bg-[#C49A6C] text-[#0B0A08] hover:bg-[#E7CBA9]" : "bg-[#8a2e2e] text-[#F2EBE1] hover:bg-[#a13838]"}`}
      >
        {isOpenNow ? <Unlock size={20} /> : <Lock size={20} />}
      </button>
      {open && (
        <SalesPanel isOpenNow={isOpenNow} mode={mode} setMode={setMode} start={start} setStart={setStart}
          end={end} setEnd={setEnd} loading={loading} onSave={save} onClose={() => setOpen(false)} />
      )}
    </>
  );
};
